<template>
  <v-row class="full-height">
    <v-col cols="12" class="pt-0">
      <v-col cols="12" class="pt-0">
        <v-card flat class="pa-0">
          <v-card-title class="pa-0">
            <v-radio-group
              row
              v-model="portalConfigurationProxy.theme"
              :mandatory="true"
              :disabled="!editMode"
              hide-details
              class="mb-2"
            >
              <template v-slot:label>
                <v-label>Thème : </v-label>
              </template>
              <v-radio label="Clair" value="light"></v-radio>
              <v-radio label="Foncé" value="dark"></v-radio>
            </v-radio-group>
            <v-spacer></v-spacer>
            <v-tooltip bottom :disabled="!editMode">
              <template #activator="{ on, attrs }">
                <v-btn
                  icon
                  @click.stop="$emit('open:palette')"
                  :disabled="!editMode"
                  color="primary"
                  v-on="on"
                  v-bind="attrs"
                >
                  <v-icon :class="!editMode ? 'fill-default' : ''"
                    >$palette</v-icon
                  >
                </v-btn>
              </template>
              <span>Utiliser la palette</span>
            </v-tooltip>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-layout align-center>
          <color-picker
            label="Primaire"
            :parentPortalConfigurationColor="
              portalConfigurationProxy.colors.primary
            "
            @update:parentPortalConfigurationColor="
              portalConfigurationProxy.colors.primary = $event;
              portalConfigurationProxy = portalConfigurationProxy;
            "
            :disabled="!editMode"
          ></color-picker>
          <v-tooltip
            bottom
            v-if="portalConfigurationProxy.colors.primary != '#281E87'"
            class="d-inline-block"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                @click="
                  portalConfigurationProxy.colors.primary = '#281E87';
                  portalConfigurationProxy = portalConfigurationProxy;
                "
                icon
                :disabled="!editMode"
                v-on="on"
                v-bind="attrs"
                small
                class="ml-2"
              >
                <v-icon :class="!editMode ? 'fill-default' : ''"
                  >$color_reset</v-icon
                >
              </v-btn>
            </template>
            <span>Retour à la valeur par défaut : #281E87</span>
          </v-tooltip>
        </v-layout>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-layout align-center>
          <color-picker
            label="Secondaire"
            :parentPortalConfigurationColor="
              portalConfigurationProxy.colors.secondary
            "
            @update:parentPortalConfigurationColor="
              portalConfigurationProxy.colors.secondary = $event;
              portalConfigurationProxy = portalConfigurationProxy;
            "
            :disabled="!editMode"
          ></color-picker>
          <v-tooltip
            bottom
            v-if="portalConfigurationProxy.colors.secondary != '#424242'"
            class="d-inline-block"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                @click="
                  portalConfigurationProxy.colors.secondary = '#424242';
                  portalConfigurationProxy = portalConfigurationProxy;
                "
                icon
                :disabled="!editMode"
                v-on="on"
                v-bind="attrs"
                small
                class="ml-2"
              >
                <v-icon :class="!editMode ? 'fill-default' : ''"
                  >$color_reset</v-icon
                >
              </v-btn>
            </template>
            <span>Retour à la valeur par défaut : #424242</span>
          </v-tooltip>
        </v-layout>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-layout align-center>
          <color-picker
            label="Background"
            :parentPortalConfigurationColor="
              portalConfigurationProxy.colors.background
            "
            @update:parentPortalConfigurationColor="
              portalConfigurationProxy.colors.background = $event;
              portalConfigurationProxy = portalConfigurationProxy;
            "
            :disabled="!editMode"
          ></color-picker>
          <v-tooltip
            bottom
            v-if="portalConfigurationProxy.colors.background != '#EAEAEA'"
            class="d-inline-block"
          >
            <template #activator="{ on, attrs }">
              <v-btn
                @click="
                  portalConfigurationProxy.colors.background = '#EAEAEA';
                  portalConfigurationProxy = portalConfigurationProxy;
                "
                icon
                :disabled="!editMode"
                v-on="on"
                v-bind="attrs"
                small
                class="ml-2"
              >
                <v-icon :class="!editMode ? 'fill-default' : ''"
                  >$color_reset</v-icon
                >
              </v-btn>
            </template>
            <span>Retour à la valeur par défaut : #EAEAEA</span>
          </v-tooltip>
        </v-layout>
      </v-col>
      <v-col cols="12" class="pt-0">
        <div class="v-label theme--light d-inline-block" style="width: 90px">
          Opacité
        </div>
        <v-text-field
          :disabled="!editMode"
          v-model.number="portalConfigurationProxy.colors.opacity"
          type="number"
          suffix="%"
          style="width: 140px"
          class="d-inline-block ml-2"
          hide-details
          dense
        ></v-text-field>
        <v-tooltip
          bottom
          v-if="portalConfigurationProxy.colors.opacity != 90"
          class="d-inline-block"
        >
          <template #activator="{ on, attrs }">
            <v-btn
              @click="
                portalConfigurationProxy.colors.opacity = 90;
                portalConfigurationProxy = portalConfigurationProxy;
              "
              icon
              :disabled="!editMode"
              v-on="on"
              v-bind="attrs"
              small
              class="ml-2"
            >
              <v-icon :class="!editMode ? 'fill-default' : ''"
                >$color_reset</v-icon
              >
            </v-btn>
          </template>
          <span>Retour à la valeur par défaut : 90%</span>
        </v-tooltip>
      </v-col>
      <v-col cols="12" v-if="editMode">
        <v-card class="pa-0" flat>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              class="mr-2"
              :disabled="!editMode || !colorsConfigChanged"
              @click.stop="$emit('cancel:colors')"
            >
              Annuler
            </v-btn>
            <v-btn
              depressed
              color="primary"
              :disabled="!editMode"
              @click.stop="$emit('save:colors')"
            >
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-col>
  </v-row>
</template>

<script>
import { computed, watch, ref } from "@vue/composition-api";
import ColorPicker from "@/components/PortalConfiguration/ColorPicker.vue";
import { usePortalConfiguration } from "@/composables/portal-configuration";

export default {
  components: {
    ColorPicker,
  },
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    isGroup: Boolean,
    id: [String, Number],
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    rules: Object,
    isPortalProfile: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    /* Import des API */
    const { initColor } = usePortalConfiguration();
    const {
      portalModels,
      portalConfigurationFormRef,
      portalProfile,
    } = usePortalConfiguration();

    /* Variables */
    const originalColors = ref(
      JSON.parse(JSON.stringify(props.portalConfiguration.colors))
    );
    const originalTheme = ref(
      JSON.parse(JSON.stringify(props.portalConfiguration.theme))
    );

    /* Computed */
    const portalConfigurationProxy = computed({
      get: function () {
        return props.portalConfiguration;
      },
      set: function (value) {
        emit("update:portalConfiguration", value);
      },
    });
    const colorsConfigChanged = computed(function () {
      const portalColors = portalConfigurationProxy.value.colors;
      const portalTheme = portalConfigurationProxy.value.theme;
      const hasChanged =
        (originalColors.value.primary &&
          originalColors.value.primary != portalColors.primary) ||
        (originalColors.value.secondary &&
          originalColors.value.secondary != portalColors.secondary) ||
        (originalColors.value.background &&
          originalColors.value.background != portalColors.background) ||
        (originalColors.value.opacity &&
          originalColors.value.opacity != portalColors.opacity) ||
        originalTheme.value != portalTheme;

      return hasChanged;
    });

    /* Watchers */
    watch(
      () => props.editMode,
      (newValue, oldValue) => {
        if (!newValue && oldValue) {
          originalColors.value = JSON.parse(
            JSON.stringify(portalConfigurationProxy.value.colors)
          );
          originalTheme.value = portalConfigurationProxy.value.theme;
        }
      }
    );

    initColor(portalConfigurationProxy.value);

    return {
      portalModels,
      portalConfigurationFormRef,
      portalProfile,
      portalConfigurationProxy,
      colorsConfigChanged,
    };
  },
  methods: {},
};
</script>
